import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DynamicItemBaseComponent } from '@ups/xplat/dynamic-render';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ups-dynamic-chart',
  template: `
    <div class="dynamic-field">
      <kendo-chart (render)="onRender($event)">
        <kendo-chart-category-axis>
          <kendo-chart-category-axis-item
            [categories]="['Jan', 'Feb', 'Mar', 'Apr']"
          ></kendo-chart-category-axis-item>
        </kendo-chart-category-axis>
        <kendo-chart-series>
          <kendo-chart-series-item
            type="verticalArea"
            [data]="[1, 2, 3, 5]"
          ></kendo-chart-series-item>
          <kendo-chart-series-item
            type="verticalArea"
            [data]="[-1, -2, -3, -5]"
          ></kendo-chart-series-item>
        </kendo-chart-series>
      </kendo-chart>
    </div>
  `,
  standalone: false,
})
export class DynamicChartComponent extends DynamicItemBaseComponent {
  private rendered = false;

  public onRender(_event?: unknown): void {
    console.log('chart render event');
    if (this.rendered) {
      return;
    }
    this.itemCreated.emit({ series: [], categories: [] });
    this.rendered = true;
  }
}
